var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 66.6673H21.6668C16.6002 66.6673 12.2779 64.9229 8.70016 61.434C5.12238 57.9229 3.3335 53.6451 3.3335 48.6006C3.3335 44.2673 4.6335 40.4007 7.2335 37.0007C9.85572 33.6007 13.2779 31.434 17.5002 30.5006C18.9002 25.3895 21.6779 21.2562 25.8335 18.1007C30.0113 14.9229 34.7335 13.334 40.0002 13.334C46.5113 13.334 52.0224 15.6007 56.5335 20.134C61.0668 24.6451 63.3335 30.1562 63.3335 36.6673C67.1779 37.1118 70.3557 38.7784 72.8668 41.6673C75.4002 44.5118 76.6668 47.8451 76.6668 51.6673C76.6668 55.8451 75.2113 59.3895 72.3002 62.3007C69.3891 65.2118 65.8446 66.6673 61.6668 66.6673H43.3335V42.834L48.6668 48.0006L53.3335 43.334L40.0002 30.0007L26.6668 43.334L31.3335 48.0006L36.6668 42.834V66.6673Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1de5088130651acf0759790e3c58f252.svg";
export { ForwardRef as ReactComponent };